/**
 * F-233: "Lembrar este dispositivo por 90 dias". The API hands a device token
 * after the code step; sent with the next logins of the same account on this
 * browser, the code is not asked until it expires. One per community and
 * e-mail (an account lives in one community, F-31), kept apart from the session
 * so logging out does not forget the device. The token is only a hash on the
 * server and is useless without the password.
 */
const PREFIX = 'memberfy_2fa_device:'

const keyOf = (communityId: string, email: string) => `${PREFIX}${communityId}:${email.trim().toLowerCase()}`

export const readDeviceToken = (communityId: string | null | undefined, email: string): string | null => {
  if (!communityId || !email) return null
  try {
    return localStorage.getItem(keyOf(communityId, email))
  } catch {
    return null
  }
}

export const saveDeviceToken = (communityId: string | null | undefined, email: string, token: string) => {
  if (!communityId || !email || !token) return
  try {
    localStorage.setItem(keyOf(communityId, email), token)
  } catch {
    /* Storage blocked: the next login asks for the code, as without the box. */
  }
}

export const forgetDeviceToken = (communityId: string | null | undefined, email: string) => {
  if (!communityId || !email) return
  try {
    localStorage.removeItem(keyOf(communityId, email))
  } catch {
    /* Nothing to forget. */
  }
}
